import styled from 'styled-components'
import { Button } from '../button/button'

export const StyledFeatureNewsCarouselContainer = styled.div`
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    display: flex;
    flex-direction: 'row';
    gap: ${props => props.theme.typography.pxToRem(41)};
  }

  ${props=> props.theme.breakpoints.up('lg')} {
    width: calc(100% + 40px);
    gap: ${props => props.theme.typography.pxToRem(150)};
  }
`

export const StyledContentSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: ${props => props.theme.typography.pxToRem(350)};
  }
`

export const StyledDate = styled.p`
  display: none;

  ${props => props.theme.breakpoints.up('sm')} {
    display: inline-block;
    font-size: ${props => props.theme.typography.pxToRem(15)};
    color: ${props => props.theme.palette.text.secondary};
    margin: ${props => props.theme.typography.pxToRem(30)} 0 ${props => props.theme.typography.pxToRem(23)} 0;
    font-weight: 500;
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(90)};
  }
`

export const StyledTitle = styled.h2`
  font-weight: 500;
  font-size: ${props => props.theme.typography.pxToRem(23)};
  color: ${props => props.theme.palette.text.primary};
  margin: ${props => props.theme.typography.pxToRem(26)} 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(24)};
    margin-top: 0;
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin: 0 0 ${props => props.theme.typography.pxToRem(30)} 0;
  }
`

export const StyledDescription = styled.p`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  color: ${props => props.theme.palette.text.secondary};
  margin-top: 0;
  margin-bottom: ${props => props.theme.typography.pxToRem(24)};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: ${props => props.theme.typography.pxToRem(42)};
  }
`

export const StyleCta = styled(Button)`
  max-width: ${props => props.theme.typography.pxToRem(160)};
  margin-top: ${props => props.theme.typography.pxToRem(16)};

  ${props=> props.theme.breakpoints.up('sm')} {
    margin-top: unset;
    max-width: ${props => props.theme.typography.pxToRem(200)};
    padding: ${props => props.theme.typography.pxToRem(15)} ${props => props.theme.typography.pxToRem(30)} ${props => props.theme.typography.pxToRem(15)} ${props => props.theme.typography.pxToRem(30)};
  }
`
